
















































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { Popover } from 'element-ui';
import { AcgnDepot } from '../index';
import { namespace } from 'vuex-class';
import event from '@acgn/herm/src/util/event';
const StaffAction = namespace('desk/staff').Action;

@Component({
  components: {
    AcgnDepot,
    [Popover.name]: Popover
  }
})

/**
 * 公共项目成员组件
 */
export default class AcgnTaskGroup extends Vue {
  @Prop() public comicId: any; // 类型列表
  @Prop({ default: true }) public isEdit: any; // 类型列表
  @StaffAction private getComicStaffList: any; // 获取项目成员
  private project: any = {};  // 项目内容
  private visible = false;
  private defaultUserImage: string = 'https://activity-resource.oss-cn-hangzhou.aliyuncs.com/h5_activity_product/icon/user_img.jpeg'; // 默认头像

  // 编辑项目
  private async created() {
    const { result } = await this.getComicStaffList({ project_id: this.comicId });
    event.emit('$projectName', result.name);
    result.allUsermessage = [];
    result.allUsermessage.push({
      dept_name: '创建人',
      members: []
    });

    const arr: any = [''];
    result.members.map((item: any) => {
      if (item.id === result.create_user_id) {
        result.allUsermessage[0].members.push(item);
      }
      const temp = arr.indexOf(item.dept_name);
      if (temp !== -1) {
        result.allUsermessage[temp].members.push(item);
      } else {
        arr.push(item.dept_name);
        result.allUsermessage.push({
          dept_name: item.dept_name,
          members: [item]
        });
      }
    });
    this.project = result;
  }

  // 获取状态
  private getStatus(status: any) {
    let sta = '';
    switch (status) {
      case 0:
        sta = '进行中';
        break;
      case 1:
        sta = '已完成';
        break;
      case 2:
        sta = '已暂停';
        break;
    }
    return sta;
  }

  // 获取回收站
  private getDepot() {
    this.visible = true;
  }

  // 编辑项目
  private editProject() {
    this.$router.push({ name: 'desk-comicAuthEdit', params: { id: this.comicId }});
  }
}
